<template>
  <div>     
    <v-container grid-list-md fluid>
      <v-layout align-center justify-space-around wrap>
        <v-flex md12>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title v-if="allClusters[clustername]">
              {{ allClusters[clustername].prettyname }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                text
                small
                @click.prevent="callListNamespaces()"
              >
                <v-icon color="primary" small>refresh</v-icon>
                Refresh Namespaces
              </v-btn>
              <v-btn
                text
                small
                @click.prevent="callListNodePools()"
              >
                <v-icon color="primary" small>refresh</v-icon>
                Refresh Node Pools
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-flex>

        <v-flex md12>
          <v-card>
            <v-card-title>Namespaces</v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex md6 v-for="ns in myNamespaces" :key="ns.name">
                  <v-card>
                    <v-card-title>
                      {{ ns.name }}
                    <v-spacer></v-spacer>
                    </v-card-title>

                    <v-card-text>
                      <v-data-table
                        :headers="headersNamespaces"
                        :items="Object.values(allApps).filter(a => a.namespace == ns.name && a.clustername == ns.clustername)"
                        :sort-by="'name'"
                        :footer-props="{
                          'items-per-page-options': [10, 50, 100]
                        }"
                        :items-per-page=50
                        item-key="name"
                        dense
                      >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.name" @click.prevent="showApp(item)" :style="{cursor:'pointer'}">
                              <td>{{ item.name }}</td>
                              <td>
                                <v-icon v-if="item.status.readyreplicas == 0 && item.status.replicas > 0" small color="error">warning</v-icon>
                                <v-icon v-else-if="item.status.readyreplicas == 0 && item.status.replicas == 0" small color="warning">stop</v-icon>
                                <v-icon v-else-if="item.status.readyreplicas < item.status.replicas" small color="warning">hourglass_full</v-icon>
                                <v-icon v-else-if="item.status.readyreplicas == item.status.replicas" small color="success">done</v-icon>
                                {{ item.status.readyreplicas }}/{{ item.status.replicas }}
                              </td>
                              <td>{{ smallStr(item.containersList[0].image.split(":")[1], 32) }}</td>
                              <!-- <td>{{ item.containersList.length }}</td> -->
                          </tr>
                        </tbody>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex md12>
          <v-card>
            <v-card-title>Node Pools</v-card-title>
            <v-card-text>
                <v-data-table
                  :headers="headersNodePools"
                  :items="Object.values(allNodePools)"
                  :sort-by="'name'"
                  :footer-props="{
                    'items-per-page-options': [10, 50, 100]
                  }"
                  :items-per-page=50
                  item-key="name"
                  dense
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.name">
                        <td>{{ item.name }}</td>
                        <td>{{ item.zone }}</td>
                        <td>{{ item.nodecount }}</td>
                        <td>{{ item.machinetype }}</td>
                        <td>{{ item.imagetype }}</td>
                        <td>{{ item.preemptible }}</td>
                    </tr>
                  </tbody>
                  </template>
                </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>

    <v-dialog
      v-model="infodialog"
      hide-overlay
      width="650"
    >
      <v-card v-if="selectedApp">
        <v-card-title>{{ selectedApp.name }}</v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{{ selectedApp.name }}</td>
              </tr>
              <tr>
                <td>Kind</td>
                <td>{{ selectedApp.kind }}</td>
              </tr>
              <tr>
                <td>Cluster</td>
                <td>{{ selectedApp.clustername }}</td>
              </tr>
              <tr>
                <td>Namespace</td>
                <td>{{ selectedApp.namespace }}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <v-icon v-if="selectedApp.status.readyreplicas == 0 && selectedApp.status.replicas > 0" small color="error">warning</v-icon>
                  <v-icon v-else-if="selectedApp.status.readyreplicas == 0 && selectedApp.status.replicas == 0" small color="warning">stop</v-icon>
                  <v-icon v-else-if="selectedApp.status.readyreplicas < selectedApp.status.replicas" small color="warning">hourglass_full</v-icon>
                  <v-icon v-else-if="selectedApp.status.readyreplicas == selectedApp.status.replicas" small color="success">done</v-icon>
                  {{ selectedApp.status.readyreplicas }}/{{ selectedApp.status.replicas }}
                </td>
              </tr>
              <tr>
                <td>Init Containers</td>
                <td>
                  <v-simple-table dense>
                    <tbody v-for="ctn in selectedApp.initcontainersList" :key="ctn.name">
                      <tr>
                        <td>Name</td>
                        <td>{{ ctn.name }}</td>
                      </tr>
                      <tr>
                        <td>Image</td>
                        <td>{{ ctn.image }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </tr>
              <tr>
                <td>Containers</td>
                <td>
                  <v-simple-table dense>
                    <tbody v-for="ctn in selectedApp.containersList" :key="ctn.name">
                      <tr>
                        <td>Name</td>
                        <td>{{ ctn.name }}</td>
                      </tr>
                      <tr>
                        <td>Image</td>
                        <td>{{ ctn.image }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="infodialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      search: '',
      clustername: this.$route.params.ClusterName,
      routechange: false,
      headersNodePools: [
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Zone', sortable: true, value: 'zone' },
        { text: 'Node Count', sortable: true, value: 'nodecount' },
        { text: 'Machine Type', sortable: true, value: 'machinetype' },
        { text: 'Image Type', sortable: true, value: 'imagetype' },
        { text: 'Preemptible', sortable: true, value: 'preemptible' }
      ],
      headersNamespaces: [
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Status', sortable: true, value: 'status.readyreplicas' },
        { text: 'Version', sortable: false, value: 'containersList' },
        // { text: 'Containers', sortable: false, value: 'containersList' }
      ],
      selectedApp: null,
      infodialog: false,
    }
  },
  computed: {
    myNamespaces: {
      get() {
        return Object.values(this.allNamespaces).filter((ns) => ns.name != 'cron' && !ns.name.startsWith('kube'));
      }
    },
    ...mapGetters(['allClusters', 'allNamespaces', 'allApps', 'allNodePools'])
  },
  components: {
  },
  watch: {
    clustername: function(v) {
      if (!this.routechange) {
        this.$router.push({ name: 'cluster', params: { ClusterName: v } });
      }
      this.cancelStreams();
      this.callListNodePools();
      this.callListNamespaces();
      this.routechange = false;
    },
    '$route.params.ClusterName': function (v) {
      if (this.clustername != v) {
        this.routechange = true;
        this.clustername = v;
      }
    }
  },
  created() {
    this.callListNodePools();
    this.callListNamespaces();
  },
  beforeDestroy() {
    this.cancelStreams();
  },
  methods: {
    callListNodePools() {
      this.resetNodePools();
      this.listNodePools({ clustername: this.clustername });
    },
    callListNamespaces() {
      this.cancelStreams();
      this.resetNamespaces();
      this.resetApps();
      this.listNamespaces({ clustername: this.clustername }).then((nss) => {
        Object.values(nss).filter((ns) =>  ns.name != 'cron' && !ns.name.startsWith('kube')).forEach((ns) => {
          this.watchApps({"namespace": ns.name, "clustername": this.clustername});
        });
      });
      this.listNamespaces({ clustername: this.clustername });
    },
    showApp(app) {
      var a = this.allApps[app.clustername+app.namespace+app.name];
      if (a) {
        this.selectedApp = a;
        this.infodialog = true;
      }
    },
    smallStr(v, n) {
      if (v && n && v.length > n && n > 3) {
        return v.slice(0, n-3) + "...";
      }
      return v
    },
    ...mapActions(['listNamespaces', 'resetNamespaces', 'listNodePools', 'resetNodePools', 'refreshTags', 'watchApps', 'resetApps', 'cancelStreams'])
  }
}
</script>
